<template>
  <AppModal :value="showModal" :title="modalTitle" @input="onClose">
    <form class="debug-package" @submit.prevent="onSubmit">
      <p v-if="errorMsg" class="debug-package__error">{{ errorMsg }}</p>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Identificadores</h4>
        <div class="debug-package__grid">
          <AppField label="ID">
            <AppInput :value="form.id" readonly disabled />
          </AppField>
          <AppField label="Código">
            <AppInput v-model="form.code" />
          </AppField>
          <AppField label="Withdrawal ID">
            <AppInput v-model="form.withdrawalId" type="number" />
          </AppField>
        </div>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Estado</h4>
        <div class="debug-package__grid">
          <AppField label="Cancelado">
            <AppCheckbox :model-value="form.isCanceled" @change="form.isCanceled = $event">isCanceled</AppCheckbox>
          </AppField>
          <AppField label="Adicional">
            <AppCheckbox :model-value="form.isAdditional" @change="form.isAdditional = $event">isAdditional</AppCheckbox>
          </AppField>
          <AppField label="Recepción">
            <AppSelect v-model="form.receptionStatus" :options="receptionStatusOptions" />
          </AppField>
          <AppField label="Tags">
            <AppSelect v-model="form.tags" :options="tagsOptions" />
          </AppField>
          <AppField label="Tamaño (size)">
            <AppInput v-model="form.size" />
          </AppField>
          <AppField label="Cantidad de bultos">
            <AppInput v-model="form.bundleQuantity" type="number" />
          </AppField>
          <AppField label="Costo de envío">
            <AppInput v-model="form.shippingCost" type="number" />
          </AppField>
          <AppField label="Modo escaneo tránsito">
            <AppSelect v-model="form.inTransitScanMode" :options="scanModeOptions" />
          </AppField>
        </div>
        <div class="debug-package__flags">
          <AppCheckbox :model-value="form.pickedUpByDriver" @change="form.pickedUpByDriver = $event">Retirado por conductor</AppCheckbox>
          <AppCheckbox :model-value="form.receivedInWarehouse" @change="form.receivedInWarehouse = $event">Recepcionado en bodega</AppCheckbox>
          <AppCheckbox :model-value="form.inTransit" @change="form.inTransit = $event">En tránsito</AppCheckbox>
          <AppCheckbox :model-value="form.exchangeOrReturn" @change="form.exchangeOrReturn = $event">Cambio o devolución</AppCheckbox>
        </div>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Destinatario</h4>
        <div class="debug-package__grid">
          <AppField label="Nombre">
            <AppInput v-model="form.customerName" />
          </AppField>
          <AppField label="Teléfono">
            <AppInput v-model="form.customerPhone" />
          </AppField>
          <AppField label="Correo">
            <AppInput v-model="form.customerEmail" type="email" />
          </AppField>
          <AppField label="Comuna (ID)">
            <AppInput v-model="form.customerCommune" type="number" />
          </AppField>
          <AppField label="Dirección">
            <AppInput v-model="form.customerAddress" />
          </AppField>
        </div>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Origen</h4>
        <div class="debug-package__grid">
          <AppField label="Source System">
            <AppInput v-model="form.sourceSystem" />
          </AppField>
          <AppField label="Source System ID">
            <AppInput v-model="form.sourceSystemId" />
          </AppField>
          <AppField label="Nº Orden origen">
            <AppInput v-model="form.sourceOrderNumber" />
          </AppField>
          <AppField label="ID Externo">
            <AppInput v-model="form.externalId" />
          </AppField>
          <AppField label="Label Code">
            <AppInput v-model="form.labelCode" />
          </AppField>
          <AppField label="Label Provider">
            <AppSelect v-model="form.labelProvider" :options="labelProviderOptions" />
          </AppField>
        </div>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Cancelación</h4>
        <div class="debug-package__grid">
          <AppField label="Motivo de cancelación">
            <AppInput v-model="form.cancelReason" />
          </AppField>
        </div>
        <AppField label="Imágenes de cancelación (JSON)">
          <AppTextarea v-model="form.cancelImages" rows="3" placeholder="[]" />
        </AppField>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Observaciones</h4>
        <AppField label="Observaciones">
          <AppTextarea v-model="form.observations" rows="3" />
        </AppField>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Datos crudos (sourceData JSON)</h4>
        <AppField label="sourceData">
          <AppTextarea v-model="form.sourceData" rows="5" placeholder="{}" />
        </AppField>
        <div class="debug-package__actions">
          <AppButton variant="danger" outline @click="form.sourceData = ''">Borrar sourceData</AppButton>
          <AppButton variant="danger" outline @click="form.cancelImages = ''">Borrar cancelImages</AppButton>
        </div>
      </section>

      <section class="debug-package__section">
        <h4 class="debug-package__section-title">Auditoría</h4>
        <div class="debug-package__grid">
          <AppField label="Retirado por (ID)">
            <AppInput v-model="form.pickedUpByDriverBy" type="number" />
          </AppField>
          <AppField label="Retirado el">
            <AppInput v-model="form.pickedUpByDriverAt" type="datetime-local" />
          </AppField>
          <AppField label="Recepcionado por (ID)">
            <AppInput v-model="form.receivedInWarehouseBy" type="number" />
          </AppField>
          <AppField label="Recepcionado el">
            <AppInput v-model="form.receivedInWarehouseAt" type="datetime-local" />
          </AppField>
          <AppField label="Tránsito por (ID)">
            <AppInput v-model="form.inTransitBy" type="number" />
          </AppField>
          <AppField label="Tránsito el">
            <AppInput v-model="form.inTransitAt" type="datetime-local" />
          </AppField>
          <AppField label="Cambio/devolución por (ID)">
            <AppInput v-model="form.exchangeOrReturnBy" type="number" />
          </AppField>
          <AppField label="Cambio/devolución el">
            <AppInput v-model="form.exchangeOrReturnAt" type="datetime-local" />
          </AppField>
          <AppField label="Cancelado por (ID)">
            <AppInput v-model="form.canceledBy" type="number" />
          </AppField>
          <AppField label="Cancelado el">
            <AppInput v-model="form.canceledAt" type="datetime-local" />
          </AppField>
          <AppField label="Etiqueta impresa por (ID)">
            <AppInput v-model="form.labelPrintedBy" type="number" />
          </AppField>
          <AppField label="Etiqueta impresa el">
            <AppInput v-model="form.labelPrintedAt" type="datetime-local" />
          </AppField>
          <AppField label="Editado por (ID)">
            <AppInput v-model="form.editedBy" type="number" />
          </AppField>
          <AppField label="Editado el">
            <AppInput v-model="form.editedAt" type="datetime-local" />
          </AppField>
        </div>
      </section>
    </form>

    <template #footer>
      <AppButton variant="secondary" outline @click="onClose">Cancelar</AppButton>
      <AppButton variant="danger" :disabled="saving" @click="onSubmit">{{ saving ? 'Guardando...' : 'Guardar debug' }}</AppButton>
    </template>
  </AppModal>
</template>

<script>
import moment from 'moment-timezone'
import AppModal from '@/components/UI/AppModal.vue'
import AppField from '@/components/UI/AppField.vue'
import AppInput from '@/components/UI/AppInput.vue'
import AppSelect from '@/components/UI/AppSelect.vue'
import AppTextarea from '@/components/UI/AppTextarea.vue'
import AppCheckbox from '@/components/UI/AppCheckbox.vue'
import AppButton from '@/components/UI/AppButton.vue'

const emptyForm = () => ({
  id: null,
  code: '',
  withdrawalId: '',
  isCanceled: false,
  isAdditional: false,
  receptionStatus: 'not_received',
  tags: '',
  size: '',
  bundleQuantity: 1,
  shippingCost: 0,
  pickedUpByDriver: false,
  receivedInWarehouse: false,
  inTransit: false,
  exchangeOrReturn: false,
  inTransitScanMode: '',
  customerName: '',
  customerPhone: '',
  customerEmail: '',
  customerAddress: '',
  customerCommune: '',
  sourceSystem: '',
  sourceSystemId: '',
  sourceOrderNumber: '',
  externalId: '',
  labelCode: '',
  labelProvider: '',
  cancelReason: '',
  cancelImages: '',
  sourceData: '',
  observations: '',
  pickedUpByDriverAt: '',
  pickedUpByDriverBy: '',
  receivedInWarehouseAt: '',
  receivedInWarehouseBy: '',
  inTransitAt: '',
  inTransitBy: '',
  exchangeOrReturnAt: '',
  exchangeOrReturnBy: '',
  canceledAt: '',
  canceledBy: '',
  labelPrintedAt: '',
  labelPrintedBy: '',
  editedAt: '',
  editedBy: ''
})

export default {
  name: 'DebugPackageForm',
  components: {
    AppModal,
    AppField,
    AppInput,
    AppSelect,
    AppTextarea,
    AppCheckbox,
    AppButton
  },
  data() {
    return {
      showModal: false,
      saving: false,
      errorMsg: '',
      form: emptyForm(),
      receptionStatusOptions: [
        { value: 'not_received', text: 'No recepcionado' },
        { value: 'received', text: 'Recepcionado' }
      ],
      tagsOptions: [
        { value: '', text: 'N/A' },
        { value: 'flex', text: 'Flex' },
        { value: 'exchange', text: 'Cambio' },
        { value: 'return', text: 'Devolución' }
      ],
      scanModeOptions: [
        { value: '', text: 'N/A' },
        { value: 'qr', text: 'QR' },
        { value: 'manual', text: 'Manual' }
      ],
      labelProviderOptions: [
        { value: '', text: 'N/A' },
        { value: 'mercado_envios_flex', text: 'Mercado Envíos Flex' },
        { value: 'internal', text: 'Interno' }
      ]
    }
  },
  computed: {
    modalTitle() {
      const ref = this.form.code || this.form.id
      return ref ? `Debug paquete ${ref}` : 'Debug paquete'
    }
  },
  methods: {
    formatDateTimeLocal(value) {
      if (!value) return ''
      const parsed = moment(value)
      return parsed.isValid() ? parsed.format('YYYY-MM-DDTHH:mm') : ''
    },
    show(pkg) {
      const item = pkg || {}
      this.errorMsg = ''
      this.saving = false
      this.form = {
        ...emptyForm(),
        id: item.id !== undefined && item.id !== null ? item.id : null,
        code: item.code || '',
        withdrawalId: item.withdrawalId !== undefined && item.withdrawalId !== null ? item.withdrawalId : '',
        isCanceled: !!item.isCanceled,
        isAdditional: !!item.isAdditional,
        receptionStatus: item.receptionStatus || 'not_received',
        tags: item.tags || '',
        size: item.size || '',
        bundleQuantity: item.bundleQuantity !== undefined && item.bundleQuantity !== null ? item.bundleQuantity : 1,
        shippingCost: item.shippingCost !== undefined && item.shippingCost !== null ? item.shippingCost : 0,
        pickedUpByDriver: !!item.pickedUpByDriver,
        receivedInWarehouse: !!item.receivedInWarehouse,
        inTransit: !!item.inTransit,
        exchangeOrReturn: !!item.exchangeOrReturn,
        inTransitScanMode: item.inTransitScanMode || '',
        customerName: item.customerName || '',
        customerPhone: item.customerPhone || '',
        customerEmail: item.customerEmail || '',
        customerAddress: item.customerAddress || '',
        customerCommune: item.customerCommune !== undefined && item.customerCommune !== null ? item.customerCommune : '',
        sourceSystem: item.sourceSystem || '',
        sourceSystemId: item.sourceSystemId || '',
        sourceOrderNumber: item.sourceOrderNumber || '',
        externalId: item.externalId || '',
        labelCode: item.labelCode || '',
        labelProvider: item.labelProvider || '',
        cancelReason: item.cancelReason || '',
        cancelImages: item.cancelImages ? JSON.stringify(item.cancelImages, null, 2) : '',
        sourceData: item.sourceData ? JSON.stringify(item.sourceData, null, 2) : '',
        observations: item.observations || '',
        pickedUpByDriverAt: this.formatDateTimeLocal(item.pickedUpByDriverAt),
        pickedUpByDriverBy: item.pickedUpByDriverBy !== undefined && item.pickedUpByDriverBy !== null ? item.pickedUpByDriverBy : '',
        receivedInWarehouseAt: this.formatDateTimeLocal(item.receivedInWarehouseAt),
        receivedInWarehouseBy: item.receivedInWarehouseBy !== undefined && item.receivedInWarehouseBy !== null ? item.receivedInWarehouseBy : '',
        inTransitAt: this.formatDateTimeLocal(item.inTransitAt),
        inTransitBy: item.inTransitBy !== undefined && item.inTransitBy !== null ? item.inTransitBy : '',
        exchangeOrReturnAt: this.formatDateTimeLocal(item.exchangeOrReturnAt),
        exchangeOrReturnBy: item.exchangeOrReturnBy !== undefined && item.exchangeOrReturnBy !== null ? item.exchangeOrReturnBy : '',
        canceledAt: this.formatDateTimeLocal(item.canceledAt),
        canceledBy: item.canceledBy !== undefined && item.canceledBy !== null ? item.canceledBy : '',
        labelPrintedAt: this.formatDateTimeLocal(item.labelPrintedAt),
        labelPrintedBy: item.labelPrintedBy !== undefined && item.labelPrintedBy !== null ? item.labelPrintedBy : '',
        editedAt: this.formatDateTimeLocal(item.editedAt),
        editedBy: item.editedBy !== undefined && item.editedBy !== null ? item.editedBy : ''
      }
      this.showModal = true
    },
    onClose() {
      this.showModal = false
    },
    async onSubmit() {
      this.saving = true
      this.errorMsg = ''
      const payload = {
        ...this.form,
        tags: this.form.tags || null,
        labelProvider: this.form.labelProvider || null,
        inTransitScanMode: this.form.inTransitScanMode || null
      }
      delete payload.id
      try {
        const res = await this.$store.dispatch('updatePackageDebug', { id: this.form.id, data: payload })
        if (res && res.status && res.status >= 400) {
          this.errorMsg = (res.data && (res.data.error || res.data.message)) || 'No se pudo actualizar el paquete'
          this.saving = false
          return
        }
        this.$toast.success('Paquete actualizado (debug)')
        this.saving = false
        this.showModal = false
        this.$emit('done', res)
      } catch (error) {
        console.error(error)
        this.errorMsg = 'No se pudo actualizar el paquete'
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .app-modal {
  max-width: 900px;
}

.debug-package {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.debug-package__error {
  margin: 0;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 0.875rem;
}

.debug-package__section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.debug-package__section-title {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  border-bottom: 1px solid var(--app-border-color, #e5e7eb);
  padding-bottom: 0.25rem;
}

.debug-package__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0 1rem;
}

.debug-package__flags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  padding-top: 0.25rem;
}

.debug-package__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
